<h1 *ngIf="!users" class="px-2 mx-auto">Loading...</h1>
<section *ngIf="users" class="flex flex-col px-2 justify-evenly">
  <div class="flex flex-row flex-wrap justify-start flex-grow mt-2">
    <a
      [routerLink]="['/admin/user/create']"
      class="inline-block px-4 py-2 mx-1 leading-none text-white bg-gray-800 border border-white rounded hover:border-orange-300 hover:text-orange-300"
      >Benutzer hinzufügen</a
    >
  </div>
  <table class="table mt-4 border-separate">
    <thead class="">
      <tr class="">
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">ID</th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Name
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Spieler-ID
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Rollen
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Notizen
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Aktualisiert
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Erstellt
        </th>
        <th class="px-2 bg-gray-800 border border-gray-800 border-solid">
          Aktionen
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of users">
        <td class="px-2 text-right border border-gray-800 border-solid">
          <a [routerLink]="['/admin/user', user.id]"> {{ user.id }} </a>
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          <a [routerLink]="['/admin/user', user.id]"> {{ user.name }} </a>
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ user.playerId }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ user.roles.join(", ") }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ user.note }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ user.updatedAt | date: "dd.MM.yyyy HH:mm" }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          {{ user.createdAt | date: "dd.MM.yyyy HH:mm" }}
        </td>
        <td class="px-2 text-right border border-gray-800 border-solid">
          <button
            class="inline-block p-2 m-1 leading-none text-white bg-gray-800 border border-white rounded hover:border-orange-300 hover:text-orange-300"
            (click)="onDeleteUser(user.id)"
          >
            Löschen
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</section>
